import React from "react";
import styles from "./LoadingScreen.module.css";

interface LoadingScreenProps {
  message?: string;
  showSpinner?: boolean;
  className?: string;
}

const LoadingScreen: React.FC<LoadingScreenProps> = ({
  message = "Loading...",
  showSpinner = true,
  className = "",
}) => {
  return (
    <div className={`${styles["loading-screen"]} ${className}`}>
      <div className={styles["loading-content"]}>
        {showSpinner && (
          <div className={styles["loading-spinner"]}>
            <div className={styles["spinner"]}></div>
          </div>
        )}
        <div className={styles["loading-message"]}>{message}</div>
      </div>
    </div>
  );
};

export default LoadingScreen;
